import { DAY_OF_BIRTH } from 'Data/common-constants.js'
import View from './view.js'
import React from 'react'

export default function Logic(props) {
  return <View viewPath={props.viewPath} from={DAY_OF_BIRTH} />
}
